import type { Guide } from '../../types';

export default (async ({ ask }) => {
  await ask('Are you happy?');

  return {};
}: Guide);
